import { analiticaInstance } from 'shared/analitica'

export const campaignEvents = analiticaInstance.eventFactory('Campaign', {
  view: {
    modalViewed: (screen: string, campaign: string) => ({
      label: 'modal-viewed',
      metadata: {
        screen,
        campaign,
        reference: 'Visualização do modal de campanha'
      }
    })
  },
  action: {
    campaignClosed: (screen: string, campaign: string) => ({
      label: 'button-clicked',
      metadata: {
        screen,
        campaign,
        'button reference': 'Clique no botão de fechar campanha'
      }
    }),
    campaignDeclined: (screen: string, campaign: string) => ({
      label: 'button-clicked',
      metadata: {
        screen,
        campaign,
        'button reference': 'Clique no botão de recusar campanha'
      }
    }),
    campaignAccepted: (screen: string, campaign: string) => ({
      label: 'button-clicked',
      metadata: {
        screen,
        campaign,
        'button reference': 'Clique no botão CTA da campanha'
      }
    })
  }
})
